import * as THREE from 'three';
import { PoiLineMeasurement, PoiMeasurementPoint } from '@/__generated__/graphql';
import { MeasurementLinesProps, Number3 } from '@fabric-web/3d-viewer';
import { DEFAULT_MEASURMENT_LINES_STYLE } from '../constants';

export const poiLineMeasurmentToProps = (
  measurement: PoiLineMeasurement | undefined
): Record<string, MeasurementLinesProps> => {
  if (!measurement?.points?.length) return {};

  const groupedByField: Record<string, Number3[]> = {};

  measurement.points.forEach((point) => {
    if (point) {
      const fieldId = point.templateFieldId;
      if (!groupedByField[fieldId]) {
        groupedByField[fieldId] = [];
      }

      groupedByField[fieldId].push([
        point.coordinates[0],
        point.coordinates[1],
        point.coordinates[2],
      ]);
    }
  });

  const fieldMeasurements: Record<string, MeasurementLinesProps> = {};

  Object.entries(groupedByField).forEach(([fieldId, vectors]) => {
    fieldMeasurements[fieldId] = {
      name: 'poi.lineMeasurement',
      points: vectors,
      style: DEFAULT_MEASURMENT_LINES_STYLE,
    };
  });

  return fieldMeasurements;
};

export const calcMeasurementLinesDistance = (points: number[][]): number => {
  return points
    .map((point) => new THREE.Vector3(...point))
    .reduce((distance: number, point, index, arr) => {
      return index === 0 ? distance : distance + point.distanceTo(arr[index - 1]);
    }, 0);
};

export const propsToPoiLineMeasurement = (
  measurementsMap: Record<string, MeasurementLinesProps> | undefined
): PoiLineMeasurement | undefined => {
  const points: PoiMeasurementPoint[] = [];

  Object.entries(measurementsMap ?? {}).forEach(([fieldId, props]) => {
    if (!props?.points?.length) return;

    props.points.forEach((point) => {
      points.push({
        coordinates: point,
        templateFieldId: fieldId,
      });
    });
  });

  if (points.length === 0) return undefined;

  return {
    points,
  };
};

export const createEmptyMeasurementProps = (
  setLineDistance?: (distance: number) => void
): MeasurementLinesProps => ({
  name: 'poi.lineMeasurement',
  points: [],
  style: DEFAULT_MEASURMENT_LINES_STYLE,
  setLineDistance,
});
